import { Api } from "../../../listsSettings/api";

export const allItems: string = `/${Api.InternalName}/_lists/${Api.Lists.UserFunctionaryPermissions.InternalName}/_pages/all_items`;
export const newForm: string = `/${Api.InternalName}/_lists/${Api.Lists.UserFunctionaryPermissions.InternalName}/_pages/new`;
export const dispForm: string = `/${Api.InternalName}/_lists/${Api.Lists.UserFunctionaryPermissions.InternalName}/_pages/disp`;
